/* src/app/shared/statistics-pos-neg/statistics-pos-neg.component.scss */
:host {
  display: block;
  margin-bottom: 40px;
}
/*# sourceMappingURL=statistics-pos-neg.component-Z4726YTA.css.map */
